import axios from 'axios'
import { ApiConfig } from '../../../../config/api'

export const getAsnDetails = (
  asnId: number,
  filterSku: string,
  page: number,
  pageSize: number
) => {
  const url = new URL(`${ApiConfig.AsnDetailApi}/reservedquantities`)

  url.searchParams.set('asnId', asnId.toString())
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filterSku) {
    url.searchParams.set('sku', filterSku)
  }

  return axios.get(url.toString())
}
